export const urlLogin = process.env.REACT_APP_LOGIN
export const urlApi = process.env.REACT_APP_API
export const urlPdfApi = process.env.REACT_APP_PDF_API
export const urlLanding = process.env.REACT_APP_LANDING
export const urlProposalLink = process.env.REACT_APP_PROPOSAL_LINK
